// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1SGZ7","buttonOutline":"styles_buttonOutline__28dUg","buttonRight":"styles_buttonRight__1zV1k"};